import { candidateFromFormatSegments, candidateParts } from './mappings';
import type { ProfileMappingCandidate, SourcePropertyDefinition } from './types';

function escapeLiteral(text: string): string {
  return text.replace(/\\/g, '\\\\').replace(/\{\{/g, '\\{{');
}

export function formatCandidateText(candidate: ProfileMappingCandidate, sources: SourcePropertyDefinition[]): string {
  return candidateParts(candidate).map((part) => {
    if (!part.sourceProperty) return escapeLiteral(part.text ?? '');
    const source = sources.find((item) => item.key === part.sourceProperty);
    return '{{' + (source?.label ?? part.sourceProperty) + '}}';
  }).join('');
}

export function parseCandidateText(
  text: string,
  sources: SourcePropertyDefinition[],
  requireAll = true,
): { candidate: ProfileMappingCandidate; error?: string } {
  const sourcesByLabel = new Map<string, SourcePropertyDefinition[]>();
  for (const source of sources) {
    const label = source.label.trim();
    sourcesByLabel.set(label, [...sourcesByLabel.get(label) ?? [], source]);
  }
  const sourceProperties: string[] = [];
  const textGaps = [''];
  const appendText = (value: string) => { textGaps[textGaps.length - 1] += value; };
  const invalid = (error: string) => ({ candidate: candidateFromFormatSegments([], [''], requireAll), error });
  let index = 0;
  while (index < text.length) {
    if (text[index] === '\\') {
      if (text[index + 1] === '\\') {
        appendText('\\');
        index += 2;
        continue;
      }
      if (text.startsWith('{{', index + 1)) {
        appendText('{{');
        index += 3;
        continue;
      }
    }
    if (text.startsWith('{{', index)) {
      const closingIndex = text.indexOf('}}', index + 2);
      if (closingIndex < 0) return invalid('직원 속성 표기 {{를 }}로 닫아 주세요.');
      const label = text.slice(index + 2, closingIndex).trim();
      if (!label) return invalid('{{ }} 안에 직원 속성 이름을 입력해 주세요.');
      const matches = sourcesByLabel.get(label);
      if (!matches?.length) return invalid('알 수 없는 직원 속성 ‘' + label + '’입니다. 속성 목록에서 선택해 주세요.');
      if (matches.length > 1) return invalid('‘' + label + '’ 이름의 직원 속성이 여러 개여서 구분할 수 없습니다.');
      sourceProperties.push(matches[0].key);
      textGaps.push('');
      index = closingIndex + 2;
      continue;
    }
    appendText(text[index]);
    index += 1;
  }
  return { candidate: candidateFromFormatSegments(sourceProperties, textGaps, requireAll) };
}
